module.exports = __webpack_public_path__ + "img/one_logo_inverted_transparent.ca8fa518.png";